import React, { Component } from 'react'
import styled from 'styled-components'
import Text from '../../components/Text'

const Box = styled.div`
  font-size: 1.1rem;
  font-weight: 300;
  margin: 1rem 0;
  text-align: center;
  width: 100%;
  &:first-child {
    margin-top: 0;
  }
  &:last-child {
    margin-bottom: 0;
  }
`

export default class Header extends Component {
  render() {
    const { str } = this.props
    return <Box><Text str={str} /></Box>
  }
}



// WEBPACK FOOTER //
// ./src/components/Card/Header.js